import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class SystemNoticeApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'systemNotice'
  }

  public getPage(CurrentPageIndex, PageSize, userId, biid){
    return this.send({CurrentPageIndex, PageSize, userId, biid},"getPage",Methods.GET)
  }

}